/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import AuthProviderForm from './AuthProviderForm';
import { getAllAuthProvider } from '../../../../../../store/reducers/authProvider/authProviderActions';
import { createAuthProvider } from '../../../../../../services/authProvider/AuthProvider';

const AuthProviderCreation = ({ handleClose }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ authProviderName }) => {
        try {
            await createAuthProvider({ authProviderName })
            toast.success('Identity Provider  was registred successfully');
            handleClose();
            dispatch(getAllAuthProvider());
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Identity Provider Registration</Typography>
            <Formik
                initialValues={{
                    authProviderName: ''
                }}
                validationSchema={Yup.object().shape({
                    authProviderName: Yup.string().min(2).max(40).required('Identity Provider Name is required.')
                })}
                onSubmit={(
                    values
                ) => {
                    handleSubmit(values)
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <AuthProviderForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}



export default AuthProviderCreation;